const deleteEmptyElementsInObjectRecursive = (jsonObject) => {
  //Near perfect recursion (if not perfect) for FHIR JSON scenarios (i.e. will not handles arrays of arrays)
  //This function will change the object sent to it. It does not make a copy of the object.
  try {
    for (const key in jsonObject) {
      let element = jsonObject[key];
      if (typeof element === "string") {
        jsonObject[key] = element.trim();
      }
      if (element === "DELETEME" || element === "" || element === undefined || element === null ||
        (typeof element === "object" && !Array.isArray(element) && Object.keys(element).length === 0) ||
        (Array.isArray(element) &&
          (element.length === 0 ||
            (element.length === 1 &&
              ((typeof element[0] === "object" && Object.keys(element[0]).length === 0) ||
                (typeof element[0] === "string" && element[0] === "")))))) {
        delete jsonObject[key];
      } else if (typeof element === "object" && !Array.isArray(element)) {
        deleteEmptyElementsInObjectRecursive(element);
        if (Object.keys(element).length === 0) {
          delete jsonObject[key];
        }
      } else if (Array.isArray(element) && typeof element[0] === "object") {
        for (let subIndex = element.length - 1; subIndex >= 0; subIndex--) { //Goes through the indexes of element in reverse
          deleteEmptyElementsInObjectRecursive(element[subIndex]);
          if (Object.keys(element[subIndex]).length === 0) {
            element.splice(subIndex, 1);
          }
        }
        if (element.length === 0) {
          delete jsonObject[key];
        }
      } else if (Array.isArray(element) &&
        (typeof element[0] === "string" || element[0] === null || element[0] === undefined)) {
        for (let subIndex = element.length - 1; subIndex >= 0; subIndex--) { //Goes through the indexes of element in reverse
          if (element[subIndex] === "" || element[0] === null || element[0] === undefined) {
            element.splice(subIndex, 1);
          }
        }
        if (element.length === 0) {
          delete jsonObject[key];
        }
      }
    }
  } catch (e) {
    console.log(e);
  }
  return jsonObject; //Not necessary since we're passing the function an address of memory and the function is modifying the object directly
}

export default deleteEmptyElementsInObjectRecursive;